import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>404</h1>
      <p style={styles.subheading}>Oops! The page you're looking for doesn't exist.</p>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#f8f9fa',
    fontFamily: 'Arial, sans-serif',
    padding: '2rem',
    textAlign: 'center',
  },
  heading: {
    fontSize: '8rem',
    color: '#343a40',
    margin: 0,
    fontWeight: 'bold',
  },
  subheading: {
    fontSize: '1.5rem',
    color: '#6c757d',
    marginTop: '1rem',
    marginBottom: '2rem',
  },
  link: {
    padding: '0.75rem 1.5rem',
    backgroundColor: '#007bff',
    color: '#fff',
    textDecoration: 'none',
    borderRadius: '0.375rem',
    fontSize: '1rem',
    transition: 'background-color 0.3s ease',
  },
};

export default NotFound;
